import { render, staticRenderFns } from "./group-tip-elem.vue?vue&type=template&id=262835ba&scoped=true"
import script from "./group-tip-elem.vue?vue&type=script&lang=js"
export * from "./group-tip-elem.vue?vue&type=script&lang=js"
import style0 from "./group-tip-elem.vue?vue&type=style&index=0&id=262835ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262835ba",
  null
  
)

export default component.exports